module.exports = __webpack_public_path__ + "static/Calibre-Medium-115d37180a9c07e2f480ca81b032babe.woff";